// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"340":"1af80785","471":"bc0509a1"}[chunkId] + ".chunk.css";
};